export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_3539bf89-c5aa-4caa-b479-39d3a96a173d/artifacts/6bl495md_Logo%20Al%20Music%20Records%20-%20Petit%202.jpg";

export const STUDIO_PHOTO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_3539bf89-c5aa-4caa-b479-39d3a96a173d/artifacts/mmy8vstz_STUDI.webp";

export const IMG = {
  console:
    "https://images.unsplash.com/photo-1518972559570-7cc1309f3229?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  micRed:
    "https://images.unsplash.com/photo-1689771455000-7ca175aa03fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  stageLights:
    "https://images.pexels.com/photos/15129779/pexels-photo-15129779.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  live:
    "https://images.pexels.com/photos/8044071/pexels-photo-8044071.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  vinyl:
    "https://images.unsplash.com/photo-1591097012573-b277e24dc210?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  hands:
    "https://images.pexels.com/photos/34538640/pexels-photo-34538640.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  gear:
    "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const EMAILS = {
  contact: "contact.almusicrecords@gmail.com",
  management: "managementalmusicrecords@gmail.com",
  studio: "almusicrecordsstudio@gmail.com",
};

export const STUDIO_INFO = {
  name: "AL MUSIC RECORDS",
  address: "19 rue d'Argenton, 72700 Allonnes",
  region: "Sarthe",
  phone: "07 82 79 85 21",
  whatsapp: "33782798521",
  email: "managementalmusicrecords@gmail.com",
  maps: "https://www.google.com/maps?q=19+rue+d'Argenton+72700+Allonnes",
  mapsEmbed: "https://www.google.com/maps?q=19+rue+d'Argenton+72700+Allonnes&output=embed",
  instagram: "https://www.instagram.com/almusicrecords/",
  facebook: "https://www.facebook.com/musichard20/",
  tiktok: "https://www.tiktok.com/@almusicrecords",
};

export function whatsappUrl(message) {
  const base = `https://wa.me/${STUDIO_INFO.whatsapp}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

export function studioBookingMessage({ nom = "", artiste = "", date = "", heure = "", prestation = "", duree = "", tarif = "", message = "" } = {}) {
  return `Bonjour AL Music Records 👋

Je souhaite réserver une session studio.

🎤 Nom : ${nom}
🎙️ Nom d'artiste : ${artiste}
📅 Date souhaitée : ${date}
🕐 Heure souhaitée : ${heure}
🎧 Prestation : ${prestation}
⏱️ Durée : ${duree}

💰 Tarif affiché : ${tarif}

Ma demande : ${message}

Merci.`;
}

export const HERO_VIDEO_ID = "QX1cwYErYHM";

export const PARTNERS = [
  { name: "ALDAM PRODUCTION / UNIVERSAL MUSIC FRANCE", url: "https://universalmusic.fr/artistes/33770613379" },
  { name: "URBAN MUSIC TOUR", url: "https://youtu.be/kJJ4hQDwDpA?si=g92oYJiLvSPx-qmm" },
  { name: "VIRGIN MUSIC AFRICA / UNIVERSAL MUSIC AFRICA", url: "https://youtu.be/1fiLKpMasmM?si=bs2rEap0iVG12nYI" },
  { name: "PIMP MUSIC / SCORPIO MUSIC", url: "https://youtu.be/-pzIEeij9l0?si=VEECvnKaWcxC74cr" },
  { name: "QLF / DTF", url: "https://fr.wikipedia.org/wiki/Elle_a" },
  { name: "UP FULL / BELIEVE", url: "https://upfullmusic.com/artiste/yvano" },
  { name: "HIT LOKAL", url: null },
  { name: "CRÉDIT AGRICOLE", url: null },
];

export const SERVICES_LIST = [
  { key: "production-musicale", title: "Production musicale", desc: "Composition, production instrumentale, arrangement, création musicale." },
  { key: "direction-artistique", title: "Direction artistique", desc: "Identité sonore, orientation artistique, arrangements, suivi." },
  { key: "production-phonographique", title: "Production phonographique", desc: "Singles, EP, albums, coproduction." },
  { key: "studio", title: "Studio", desc: "Enregistrement, voix, voix off, captation sonore." },
  { key: "mixage-mastering", title: "Mixage & mastering", desc: "Édition, traitement vocal, mixage, mastering." },
  { key: "production-sonore", title: "Production sonore", desc: "Montage, post-production, sound design, habillage sonore, bruitage." },
  { key: "audiovisuel", title: "Audiovisuel", desc: "Voix off, post-production sonore, mixage, mastering, exports." },
  { key: "accompagnement-artistique", title: "Accompagnement artistique", desc: "Développement, structuration, préparation des sorties." },
  { key: "booking", title: "Booking", desc: "Développement, prospection, coordination." },
  { key: "projets-culturels", title: "Projets culturels", desc: "Ateliers, transmission, actions culturelles." },
];
